import axios from 'axios';
import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import filterObjectToQuery from '../../utils/filterObjectToQuery';
import moment from 'moment';

const { CancelToken } = axios;

let fetchExpiredServices_cancel;
let fetchExpiredServicesBadge_cancel;
let fetchExpiredServicesExport_cancel;

export const setExpiredServicesFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_EXPIRED_SERVICES_FILTER,
    expiredServicesFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const fetchExpiredServicesSuccess = (expiredServicesEvents, after, before) => ({
    type: actionTypes.FETCH_EXPIRED_SERVICE_SUCCESS,
    expiredServicesEvents,
    after,
    before,
  }); 

export const requestExpiredServicesFail = error => ({
    type: actionTypes.REQUEST_EXPIRED_SERVICE_FAIL,
    error,
  });

export const fetchExpiredServicesBadgeSuccess = (badge) => ({
    type: actionTypes.FETCH_EXPIRED_SERVICES_BADGE_SUCCESS,
    badge: badge.count
  }); 

export const requestExpiredServicesBadgeFail = error => ({
    type: actionTypes.REQUEST_EXPIRED_SERVICE_BADGE_FAIL,
    error,
  });

export const fetchExpiredServicesBadge = () => {
  fetchExpiredServicesBadge_cancel && fetchExpiredServicesBadge_cancel()
  return dispatch => new Promise((resolve, reject) => {
    dispatch(requestExpiredServicesBadgeStart());
      API.get(`/expired-services/count`, {
        cancelToken: new CancelToken(((c) => {
          fetchExpiredServicesBadge_cancel = c;
        })),
      })
        .then((res) => {
          dispatch(fetchExpiredServicesBadgeSuccess(res.data));
          resolve('success');
        })
        .catch((err) => {
          dispatch(requestExpiredServicesBadgeFail(err));
        });
  });
};

export const requestExpiredServicesBadgeStart = () => ({
  type: actionTypes.REQUEST_EXPIRED_SERVICE_BADGE_START,
});

export const requestExpiredServicesStart = () => ({
    type: actionTypes.REQUEST_EXPIRED_SERVICE_START,
  });

// filter

export const filterExpiredServiceStartDate = (startDate) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICE_START_DATE,
    startDate,
  };
};

export const filterExpiredServiceStartDateRemove = (startDate) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICE_START_DATE_REMOVE,
    startDate,
  };
};

export const filterExpiredServiceEndDate = (endDate) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICE_END_DATE,
    endDate,
  };
};

export const filterExpiredServiceEndDateRemove = (endDate) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICE_END_DATE_REMOVE,
    endDate,
  };
};

export const filterExpiredServiceTypes = (serviceTypes) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICE_TYPES,
    serviceTypes,
  };
};

export const filterExpiredServiceTypesRemove = (serviceType) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICE_TYPES_REMOVE,
    serviceType,
  };
};

export const filterExpiredServicesEquipmentGroups = equipmentGroups => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS,
    equipmentGroups,
});

export const filterExpiredServicesEquipmentGroupsRemove = equipmentGroup => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS_REMOVE,
    equipmentGroup,
});

export const filterExpiredServicesPlaces = places => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_PLACES,
    places,
});

export const filterExpiredServicesPlacesRemove = place => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_PLACES_REMOVE,
    place,
});

export const filterExpiredServicesEquipmentModels = equipmentModels => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_MODELS,
    equipmentModels,
});

export const filterExpiredServicesEquipmentModelsRemove = equipmentModel => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_MODELS_REMOVE,
    equipmentModel,
});

export const filterExpiredServicesAreas = areas => ({
  type: actionTypes.FILTER_EXPIRED_SERVICES_AREAS,
  areas,
});

export const filterExpiredServicesAreasRemove = area => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_AREAS_REMOVE,
    area,
});

export const filterExpiredServicesCompanies = companies => ({
  type: actionTypes.FILTER_EXPIRED_SERVICES_COMPANIES,
  companies,
});

export const filterExpiredServicesCompaniesRemove = company => ({
  type: actionTypes.FILTER_EXPIRED_SERVICES_COMPANIES_REMOVE,
  company,
});

export const filterExpiredServicesFrequencies = (frequencies) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICES_FREQUENCIES,
    frequencies,
  };
};

export const filterExpiredServicesFrequenciesRemove = (frequency) => {
  return {
    type: actionTypes.FILTER_EXPIRED_SERVICES_FREQUENCIES_REMOVE,
    frequency,
  };
};

export const filterExpiredServicesClear = () => ({
    type: actionTypes.FILTER_EXPIRED_SERVICES_CLEAR,
});

export const fetchExpiredServices = (page, limit, search, order, orderBy, after, before, sites, filteredEquipmentModels, filteredEquipmentGroups, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies, showMandatoryServices, showNonMandatoryServices) => {
  fetchExpiredServices_cancel && fetchExpiredServices_cancel();
  const beforeISO = before ? moment(before).toISOString() : moment().toISOString();

  return dispatch => new Promise((resolve, reject) => {
      dispatch(requestExpiredServicesStart());
      dispatch(setExpiredServicesFilter(page, limit, search, order, orderBy));
      let showMandatory = (showMandatoryServices && !showNonMandatoryServices);
      let showNonMandatory = (showNonMandatoryServices && !showMandatoryServices);

      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
      queryParams += `&before=${beforeISO}`;
      queryParams += `${after && after.length > 0 ? `&after=${moment(after).toISOString()}` : ''}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceTypes=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `&showMandatoryServices=${showMandatory}`;
      queryParams += `&showNonMandatoryServices=${showNonMandatory}`;
      
      API.get(`/expired-services${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchExpiredServices_cancel = c;
        })),
      })
        .then((res) => {
          dispatch(fetchExpiredServicesSuccess(res.data, after, before));
          resolve('success');
        })
        .catch((err) => {
          dispatch(requestExpiredServicesFail(err));
        });
  });
};

export const fetchExpiredServicesExport = (search, order, orderBy, after, before, sites, filteredEquipmentModels, filteredEquipmentGroups, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies, showMandatoryServices, showNonMandatoryServices, emailLanguage) => {
  fetchExpiredServicesExport_cancel && fetchExpiredServicesExport_cancel();
  const beforeISO = before ? moment(before).toISOString() : moment().toISOString();

  return dispatch => new Promise((resolve, reject) => {
    let showMandatory = (showMandatoryServices && !showNonMandatoryServices);
    let showNonMandatory = (showNonMandatoryServices && !showMandatoryServices);

    let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    queryParams += `&before=${beforeISO}`;
    queryParams += `${after && after.length > 0 ? `&after=${moment(after).toISOString()}` : ''}`;
    queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
    queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
    queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
    queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
    queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceTypes=' + filterObjectToQuery(filteredServiceTypes) : ''}`
    queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
    queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
    queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
    queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;
    queryParams += `&showMandatoryServices=${showMandatory}`;
    queryParams += `&showNonMandatoryServices=${showNonMandatory}`;
 
    API.get(`/expired-services/export${queryParams}`, {
      cancelToken: new CancelToken(((c) => {
        fetchExpiredServicesExport_cancel = c;
      })),
    })
      .then((res) => {;
        resolve(res.data);
      })
      .catch((err) => {
        toastr.error('Erro', err)
        reject(err);
      });
  });
}

export const expiredServicesSetShowMandatoryServicesFilter = (show) => ({
  type: actionTypes.EXPIRED_SERVICES_FILTER_SHOW_MANDATORY_SERVICES,
  payload: show,
});

export const expiredServicesSetShowNonMandatoryServicesFilter = (show) => ({
  type: actionTypes.EXPIRED_SERVICES_FILTER_SHOW_NON_MANDATORY_SERVICES,
  payload: show,
});